/* global axios */
import Auth from './auth';
import {VUE_APP_API_FLOWS_BASE_URL,VUE_APP_API_CAMPAINGS_BASE_URL ,VUE_APP_API_INBOXES_BASE_URL } from '../../config/index'

const DEFAULT_API_VERSION = 'v1';

class ApiCampains {
  constructor(resource, options = {}) {
    this.apiVersion = `/api/${options.apiVersion || DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  get url() {
    return `${this.baseUrl()}/${this.resource}`;
  }

  get accountIdFromRoute() {
    const isInsideAccountScopedURLs = window.location.pathname.includes('/app/accounts');
    if (isInsideAccountScopedURLs) {
      return window.location.pathname.split('/')[3];
    }
    return '';
  }

  baseUrl() {
   let url =VUE_APP_API_FLOWS_BASE_URL;
    return url;
  }

  baseCampaingUrl() {
   let url = VUE_APP_API_CAMPAINGS_BASE_URL;
   return url;
  }


  baseInboxesUrl() {
   let url = VUE_APP_API_INBOXES_BASE_URL;
   return url;
  }

  baseFlowsUrl() {
   let url = VUE_APP_API_FLOWS_BASE_URL;
   return url;
  }

  get(params) {
    return axios.get(this.baseCampaingUrl()+"/accounts/"+this.accountIdFromRoute+"/campaign-manager/campaigns", {
      params: params/*,
      headers:{'access-token': "i66CKjC2rpqW4bPSJ5jR7Q",
      'token-type': "Bearer",
      'client':"dn1y9Tl4ykPOWeSmhKzIAg",
      'expiry':1769963247,
      'uid':"jjvasquezcabos@gmail.com",}*/
    });
  }


  getCampaignDetailPanel(id) {
    return axios.get(this.baseCampaingUrl()+"/accounts/"+this.accountIdFromRoute+"/campaign-manager/campaigns/"+id);
  }

  getCampaignDetailConversations(id,params){
    return axios.get(this.baseCampaingUrl()+"/accounts/"+this.accountIdFromRoute+"/campaign-manager/campaigns/"+id+"/conversations", {
      params: params/*,
      headers:{'access-token': "g5uFvTYMsO2m0VlNTrIpXw",
      'token-type': "Bearer",
      'client':"J3EEIwNzw6yF9qke5acDiA",
      'expiry':1744386126,
      'uid':"jjvasquezcabos@gmail.com",}*/
      
    });
  }

  exportCampaignDetailConversations(id,params){
    return axios.get(this.baseCampaingUrl()+"/accounts/"+this.accountIdFromRoute+"/campaign-manager/campaigns/"+id+"/conversations", {
      params: params/*,
      headers:{'access-token': "g5uFvTYMsO2m0VlNTrIpXw",
      'token-type': "Bearer",
      'client':"J3EEIwNzw6yF9qke5acDiA",
      'expiry':1744386126,
      'uid':"jjvasquezcabos@gmail.com",}*/
      
    });
  }

  getFlowList(){
    return axios.get(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows?fields=id,name&order=name&sort=asc&limit=100"/*,
    {
      headers:{'access-token': "bfnpDg3ZcEUQ_s4VyVAong",
      'token-type': "Bearer",
      'client':"SkUYKNGrmwhCrKDTcAlNxA",
      'expiry':1744386126,
      'uid':"jjvasquezcabos@gmail.com",}
    }*/
  );
  }



  getInboxList(){
   return axios.get(this.baseInboxesUrl()+"/accounts/" + this.accountIdFromRoute + "/inboxes?fields=id,name");
  }


  getTemplateList(inboxID){
    return axios.get(this.baseCampaingUrl()+"/accounts/" + this.accountIdFromRoute + "/campaign-manager/inboxes/" + inboxID + "/templates?fields=custom");
  }

  uploadFile(formData){
    return axios.post(this.baseCampaingUrl()+"/accounts/" + this.accountIdFromRoute + "/campaign-manager/files",formData);
  }

  getFileBlob(params){
    return axios.get(this.baseCampaingUrl()+"/accounts/" + this.accountIdFromRoute + "/campaign-manager/files/1",{
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },responseType: 'blob'
    });
  }

  show(id) {
    return axios.get(this.baseFlowsUrl()+"/accounts/" + this.accountIdFromRoute + "/flow-manager/flows/1234/auth");
  }

  getTypeBotToken() {
    return axios.get(this.baseFlowsUrl()+"/accounts/" + this.accountIdFromRoute + "/flow-manager/flows/1234/auth");
  }

  create(data) {
    return axios.post(this.baseCampaingUrl()+"/accounts/"+this.accountIdFromRoute+"/campaign-manager/campaigns", data/*,{
      
      headers:{'access-token': "g5uFvTYMsO2m0VlNTrIpXw",
      'token-type': "Bearer",
      'client':"J3EEIwNzw6yF9qke5acDiA",
      'expiry':1744386126,
      'uid':"jjvasquezcabos@gmail.com",}
    }*/);
  }

 

  sendTestMessage(data) {
    return axios.post(this.baseFlowsUrl()+"/whatsapp/templates", data/*,{
      
      headers:{'access-token': "g5uFvTYMsO2m0VlNTrIpXw",
      'token-type': "Bearer",
      'client':"J3EEIwNzw6yF9qke5acDiA",
      'expiry':1744386126,
      'uid':"jjvasquezcabos@gmail.com",}
    }*/);
  }

  publish(flowId) {
    return axios.post(this.baseFlowsUrl()+"/accounts/" + this.accountIdFromRoute + "/flow-manager/flows/" + flowId + "/publish", { status: 1 });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(flowId) {
    return axios.delete(this.baseCampaingUrl()+`/accounts/${this.accountIdFromRoute}/campaign-manager/campaigns/${flowId}`);
  }

  getContactsAndConversations(id,params){
    return axios.get(this.baseCampaingUrl()+"/accounts/"+this.accountIdFromRoute+"/report-manager/reports", {
      params: params/*,
      headers:{'access-token': "g5uFvTYMsO2m0VlNTrIpXw",
      'token-type': "Bearer",
      'client':"J3EEIwNzw6yF9qke5acDiA",
      'expiry':1744386126,
      'uid':"jjvasquezcabos@gmail.com",}*/
      
    });
  }

}

export default ApiCampains;
